var render, staticRenderFns
import script from "./PzLoaderMixins.vue?vue&type=script&lang=js&"
export * from "./PzLoaderMixins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\clientesapp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f6da322')) {
      api.createRecord('0f6da322', component.options)
    } else {
      api.reload('0f6da322', component.options)
    }
    
  }
}
component.options.__file = "src/commons/PzLoaderMixins.vue"
export default component.exports